// extracted by mini-css-extract-plugin
export default {"sidebarWidth":"352px","headerHeight":"70px","display":"Woz8P7","sidebarVisible":"VrNsdE","newViewerPage":"Hx6KRG","fullWidth":"pLF8IX","iframe":"eZTjsa"};